import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { getUserOrgId } from "../getUserOrgId";
import postSiteMarketplaceGraphs from "../http/postSiteMarketplaceGraphs";
import { SdmMatchConfig, SiteMarketplaceGraphs } from "../models/site";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useSiteMarketplaceGraphs = ({
  siteId,
  extraSdmBuyOffer,
  userOrgId,
}: {
  siteId: string;
  extraSdmBuyOffer?: SdmMatchConfig;
  userOrgId?: string;
}) => {
  const { getToken, getClaim } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchSiteMarketplaceGraphs: UseQueryResult<
    { curves: SiteMarketplaceGraphs },
    unknown
  > = useQuery(
    ["site", siteId, "marketplace-graphs", extraSdmBuyOffer],
    async () => {
      return postSiteMarketplaceGraphs(
        await getAuthTokenBlocking(getToken, relogin),
        siteId,
        extraSdmBuyOffer,
        await getUserOrgId(getClaim, userOrgId)
      );
    },
    {
      // Allow query to be mounted multiple times on the same page without re-fetching
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    fetchSiteMarketplaceGraphs,
  };
};

export default useSiteMarketplaceGraphs;
